<cass-core-toolbar></cass-core-toolbar>
<div class='page-container'>
	<div class="customer-contact-page-panel">

		<mat-card class="branding--customer-contact-title-card branding--title-card">
			<mat-card-content>
				<div class="customer-contact-title-card">
					<h1>{{ contact?.id ? contact?.firstName + " " + contact?.lastName : ("CUSTOMER_DETAILS.CONTACT_DETAILS.TITLE_NEW_CONTACT_FOR" | translate) + " " + customer?.name }}</h1>
				</div>
			</mat-card-content>
		</mat-card>

		<mat-card class="branding--customer-contact-detail-card branding--section-card">
			<mat-card-content>
				<form [formGroup]="form" class="customer-contact-details-form">
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.CONTACT_DETAILS.FIRST_NAME" | translate }}</mat-label>
						<input matInput formControlName="firstName" required [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="firstName"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.CONTACT_DETAILS.LAST_NAME" | translate }}</mat-label>
						<input matInput formControlName="lastName" required [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="lastName"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.CONTACT_DETAILS.EMAIL" | translate }}</mat-label>
						<input matInput formControlName="email" required [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="email"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.CONTACT_DETAILS.PHONE" | translate }}</mat-label>
						<input matInput formControlName="phone" [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="phone"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.CONTACT_DETAILS.MOBILE" | translate }}</mat-label>
						<input matInput formControlName="mobile" [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="mobile"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.CONTACT_DETAILS.FAX" | translate }}</mat-label>
						<input matInput formControlName="fax" [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="fax"></mat-error>
					</mat-form-field>
					<mat-form-field class="span-2">
						<mat-label>{{ "CUSTOMER_DETAILS.CONTACT_DETAILS.ADDRESS" | translate }}</mat-label>
						<input matInput formControlName="address" [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="address"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.CONTACT_DETAILS.CITY" | translate }}</mat-label>
						<input matInput formControlName="city" [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="city"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.CONTACT_DETAILS.PROVINCE" | translate }}</mat-label>
						<input matInput formControlName="province" [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="province"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.CONTACT_DETAILS.COUNTRY" | translate }}</mat-label>
						<mat-select [(value)]="Country" [disabled]="isReadOnly()">
							<mat-option *ngFor="let c of countries" [value]="c.code">{{c.label}}</mat-option>
						</mat-select>
						<mat-error [cassErrorForFormControl]="country"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.CONTACT_DETAILS.ZIPCODE" | translate }}</mat-label>
						<input matInput formControlName="zipcode" [readonly]="isReadOnly()" autocomplete="off">
						<mat-error [cassErrorForFormControl]="zipcode"></mat-error>
					</mat-form-field>
					<!-- TODO job role/title should be implemented -->
					<!--mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.CONTACT_DETAILS.JOB_ROLE" | translate }}</mat-label>
						<input matInput formControlName="jobRole" [readonly]="isReadOnly()">
						<mat-error [cassErrorForFormControl]="jobRole"></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label>{{ "CUSTOMER_DETAILS.CONTACT_DETAILS.JOB_TITLE" | translate }}</mat-label>
						<input matInput formControlName="jobTitle" [readonly]="isReadOnly()">
						<mat-error [cassErrorForFormControl]="jobTitle"></mat-error>
					</mat-form-field-->
				</form>
				<mat-checkbox [checked]="this.getIsDefault()" (change)="isDefaultToggle()"> {{ "CUSTOMER_DETAILS.CONTACT_DETAILS.IS_DEFAULT" | translate }} </mat-checkbox>
				<mat-checkbox [checked]="this.getIsMaterial()" (change)="isMaterialToggle()"> {{ "CUSTOMER_DETAILS.CONTACT_DETAILS.IS_MATERIAL" | translate }} </mat-checkbox>
				<mat-checkbox [checked]="this.getIsProof()" (change)="isProofToggle()"> {{ "CUSTOMER_DETAILS.CONTACT_DETAILS.IS_PROOF" | translate }} </mat-checkbox>
			</mat-card-content>
		</mat-card>

		<mat-card class="branding--section-card">
			<mat-card-content>
				<mat-checkbox [(ngModel)]="isGdprConsentAccepted">{{ "CUSTOMER_DETAILS.CONTACT_DETAILS.GDPR_LEGAL_INFO" | translate }}</mat-checkbox>
			</mat-card-content>
		</mat-card>

		<mat-card class="branding--action-card button-container">
			<mat-card-content>
				<div class="button-container">
					<button *ngIf="!isReadOnly()" mat-raised-button color="primary" [disabled]="!isValid()" (click)="modifyCustomerContact()">{{ "ACTION_BUTTON_LABELS.SAVE" | translate }}</button>
					<button *ngIf="!isReadOnly()" mat-stroked-button (click)="closeCustomerContact()">{{ "ACTION_BUTTON_LABELS.DISCARD_CHANGES" | translate }}</button>
					<button *ngIf="contact?.id" mat-button color="warn" (click)='confirmDeleteCustomerContact()'>{{ "ACTION_BUTTON_LABELS.DELETE" | translate }}</button>
				</div>
			</mat-card-content>
		</mat-card>
	</div>
</div>
